<template>

  <b-row>
    <b-col>
      <b-card title="Filters">
        <b-form @keyup.enter="filterData">
          <b-row>
            <b-col>
              <b-form-group
                label="Parcel tracking number"
                label-for="tracking-number"
              >
                <b-form-input
                  id="parcel-tracking-number"
                  v-model="filters.tracking_number"
                  name="tracking-number"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group
                label="Document number"
                label-for="document-number"
              >
                <b-form-input
                  id="document-number"
                  v-model="filters.document_number"
                  name="document-number"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Date range"
                label-for="date-range"
              >
                <flat-pickr
                  id="date-range"
                  v-model="filters.dateRange"
                  class="form-control"
                  :config="{ mode: 'range' }"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Status"
                label-for="status"
              >
                <v-select
                  v-model="selectedFilterStatus"
                  :options="statusOptions"
                  :clearable="false"
                  input-id="status"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="IO"
                label-for="io"
              >
                <v-select
                  v-model="ioSelected"
                  :options="suggestionListIo"
                  label="label"
                  :reduce="option => option.value"
                  input-id="io"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Type"
                label-for="type"
              >
                <b-form-input
                  id="type"
                  v-model="filters.type"
                  name="type"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="LRN"
                label-for="lrn"
              >
                <b-form-input
                  id="lrn"
                  v-model="filters.lrn"
                  name="lrn"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="MRN"
                label-for="mrn"
              >
                <b-form-input
                  id="mrn"
                  v-model="filters.mrn"
                  name="mrn"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="Body"
                label-for="body"
              >
                <b-form-input
                  id="body"
                  v-model="filters.body"
                  name="body"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="4"
              lg="4"
              md="4"
            >
              <b-button
                class="mt-2"
                type="button"
                variant="primary"
                @click="filterData()"
              >
                Filter
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import { parseFilters } from '@core/utils/filter'
import { EventBus } from '@core/utils/utils'
import { buildQueryFromFilters, pushQueryIfChanged, restoreFiltersFromQuery } from '@core/utils/filterQuerySync'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BForm,
    BFormGroup,
    flatPickr,
    BFormInput,
    BCard,
    vSelect,
  },
  props: ['statuses'],
  data() {
    return {
      suggestionListIo: [
        { label: 'Incoming', value: 'incoming' },
        { label: 'Outgoing', value: 'outgoing' },
      ],
      companyList: [],
      filters: {
        io: '',
        type: '',
        lrn: '',
        mrn: '',
        body: '',
        tracking_number: '',
        document_number: '',
        status: '',
        dateRange: '',
      },
      selectedFilterStatus: null,
    }
  },
  computed: {
    statusOptions() {
      const statuses = []
      statuses.push({
        label: 'N/A',
        value: '',
      })
      this.statuses.forEach(item => {
        statuses.push({
          label: item,
          value: item,
        })
      })
      return statuses
    },
    ioSelected: {
      get() {
        return this.filters.io
      },
      set(val) {
        this.filters.io = val === null ? '' : val
      },
    },
  },
  watch: {
    statusOptions(options) {
      if (!this.selectedFilterStatus && this.filters.status) {
        this.selectedFilterStatus = options.find(s => s.value === this.filters.status) || null
      }
    },
  },
  mounted() {
    this.restoreFiltersFromQuery()
  },
  methods: {
    restoreFiltersFromQuery() {
      const restored = restoreFiltersFromQuery(this.$route.query, this.filters, {
        tracking_number: 'string',
        document_number: 'string',
        dateRange: 'string',
        type: 'string',
        lrn: 'string',
        mrn: 'string',
        body: 'string',
        io: 'string',
        status: 'string',
      })
      if (restored && this.filters.status) {
        this.selectedFilterStatus = this.statusOptions.find(s => s.value === this.filters.status) || null
      }
      this.filterData()
    },
    filterData() {
      if (this.selectedFilterStatus) {
        this.filters.status = this.selectedFilterStatus.value
      }
      pushQueryIfChanged(this.$router, this.$route, buildQueryFromFilters(this.filters))
      this.filters.page = 1
      EventBus.$emit('updateFilters', parseFilters(this.filters))
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
